import CroustilleElement from '../lib/CroustilleElement'

class Alert extends CroustilleElement {
  constructor() {
    super('alert')
  }

  onClick(e) {
    this.remove()
  }

  init() {
    this.onClick = this.onClick.bind(this)
    this.addEventListener('click', this.onClick)
    setTimeout(this.onClick, 5000)
  }

  destroy() {
    this.removeEventListener('click', this.onClick)
  }
}

export default Alert
